/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelManifestLookup.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/manifest-lookup";

export class AutogenModelManifestLookup<RowType extends ModelRow> extends Endpoint<RowType, RowManifestLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowManifestLookup extends ModelRow<RowManifestLookupFields> {
	constructor(values?: Partial<RowManifestLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowManifestLookupFields {
	dest_stop_id: string;
	id: string;
	origin_stop_id: string;
	"stop.actual_arrival": Date;
	"stop.actual_departure": Date;
	"stop.address": string;
	"stop.address2": string;
	"stop.appointment_status_id": string;
	"stop.appt_contact_name": string;
	"stop.appt_required": string;
	"stop.cases": number;
	"stop.city_id": number;
	"stop.city_name": string;
	"stop.company_id": string;
	"stop.confirmed": string;
	"stop.contact_email": string;
	"stop.contact_name": string;
	"stop.dist_from_prev": number;
	"stop.dist_from_prev_um": string;
	"stop.driver_load_unload": string;
	"stop.edi_code": string;
	"stop.edi_loc_code": string;
	"stop.eta": Date;
	"stop.eta_distance": number;
	"stop.eta_late": string;
	"stop.eta_oor": string;
	"stop.google_place_id": string;
	"stop.grouped_id": number;
	"stop.hub": number;
	"stop.ic_stop_id": string;
	"stop.id": string;
	"stop.inbound_status": string;
	"stop.late_eta_colorcode": string;
	"stop.late_route_status": string;
	"stop.latitude": number;
	"stop.location_id": string;
	"stop.location_name": string;
	"stop.longitude": number;
	"stop.manifest_fgp_uid": number;
	"stop.manifest_reg_uid": number;
	"stop.move_dist_from_preassign": number;
	"stop.move_dist_from_preassign_um": string;
	"stop.move_dist_from_previous": number;
	"stop.move_dist_from_previous_um": string;
	"stop.movement_id": string;
	"stop.movement_sequence": number;
	"stop.operational_status": string;
	"stop.order_id": string;
	"stop.order_sequence": number;
	"stop.orig_sched_early": Date;
	"stop.orig_sched_late": Date;
	"stop.pallets_dropped": number;
	"stop.pallets_picked_up": number;
	"stop.payment_code_reviewed": string;
	"stop.phone": string;
	"stop.planned_arrival_time": Date;
	"stop.ponum": string;
	"stop.prior_uncleared_stops": string;
	"stop.projected_arrival": Date;
	"stop.pu_override_arrive_early": Date;
	"stop.pu_override_arrive_late": Date;
	"stop.rate_dist_from_previous": number;
	"stop.rate_dist_from_previous_um": string;
	"stop.refno": string;
	"stop.requested_service": string;
	"stop.sched_arrive_early": Date;
	"stop.sched_arrive_late": Date;
	"stop.seal": string;
	"stop.service_date": Date;
	"stop.showas_address": string;
	"stop.showas_address2": string;
	"stop.showas_city_id": number;
	"stop.showas_city_name": string;
	"stop.showas_location_id": string;
	"stop.showas_location_name": string;
	"stop.showas_state": string;
	"stop.showas_zip_code": string;
	"stop.signed_for_name": string;
	"stop.state": string;
	"stop.status": string;
	"stop.stop_type": string;
	"stop.trimble_place_id": string;
	"stop.txl_uid": number;
	"stop.volume": number;
	"stop.volume_um": string;
	"stop.weight": number;
	"stop.weight_um": string;
	"stop.zip_code": string;
	"stop.zone_id": string;
}

